<template>
  <div class="normalized-names-list">
    <ul class="__container">
      <li
        v-for="(name, index) in normalizedNames"
        :key="index"
        class="__item-container"
        @click="isManager && onEdit(name)"
      >
        <span>
          {{ name.normalizedName }}
        </span>
        <BaseMoreActions
          v-if="isManager"
          :title="name.normalizedName"
          menu-class="__actions-menu"
          :actions="rowActions"
          @select="$event === 'edit' ? onEdit(name) : onDelete(name)"
        />
      </li>
      <div class="__empty" v-if="normalizedNames.length === 0">
        {{ $t('page.admin-tenant.normalized-names.empty') }}
      </div>
    </ul>
  </div>
</template>

<script>
import BaseMoreActions from '@/components/base/BaseMoreActions.vue';

import { mapGetters } from 'vuex';

export default {
  name: 'NormalizedNamesList',
  components: {
    BaseMoreActions,
  },
  props: {},
  data() {
    return {
      selectedNames: [],
      itemsPerPage: 5,
      showAll: false,
    };
  },
  computed: {
    rowActions() {
      return [
        { key: 'edit', label: this.$t('actions.edit'), icon: 'edit-2' },
        { key: 'delete', label: this.$t('actions.delete'), icon: 'trash-2', danger: true },
      ];
    },
    ...mapGetters('tenant', ['normalizedNames']),
    ...mapGetters('auth', ['isManager']),
  },
  methods: {
    onEdit(item) {
      this.$emit('on-edit', item);
    },
    onDelete(item) {
      this.$emit('on-delete', item);
    },
  },
};
</script>

<style lang="scss">
.normalized-names-list {
  list-style-type: none;

  > .__container {
    .__item-container {
      cursor: pointer;
      padding: 8px;
      margin-bottom: 8px;
      border-radius: $border-radius-medium;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:hover {
        background-color: $color-hover;
      }
    }

    .__empty {
      display: flex;
      color: $color-neutral;
    }

    .__actions-menu {
      cursor: pointer;
      background-color: $color-white;
    }
  }
}
</style>
